var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 1707 1707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M850 1707c-466 0-795-368-842-744C-59 441 339 61 743 7c234-30 464 35 644 181 170 137 284 339 312 554 30 228-30 451-170 629-140 181-348 299-572 327-34 6-70 9-107 9z",
    "data-original": "#05aac0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edf9ff",
    d: "M850 1707c-241 0-445-99-593-245 128-71 125-73 260-123 116-41 133-47 129-144-4-62-29-26-65-126-4-12-12-37-23-46-24-27-84-98-54-195 15-50 8-41 0-95-11-70-13-174 15-247 52-133 178-204 352-195 126 6 113 46 185 71 129 43 183 185 142 380-11 49-22 44-6 84 17 45 8 86-3 122-24 80-24 8-68 116-27 64-67 92-69 118-13 108 28 123 148 168 44 16 176 71 246 114-134 128-306 211-489 234-34 6-70 9-107 9z",
    "data-original": "#9dffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.17f847a6fa025f93310d22f86835fe3a.svg";
export { ForwardRef as ReactComponent };